export default {
  removeDragState(content) {
    if( !content ) return;
    content
      .querySelectorAll('.draggable-source--is-dragging')
      .forEach(draggable => draggable.remove());
    content
      .querySelectorAll('.draggable-mirror')
      .forEach(draggable => draggable.remove());
    content.querySelectorAll('.draggable--original').forEach(draggable => {
      draggable.classList.remove('draggable--original');
      draggable.style.display = '';
    });
  }
};
